export default {
      id: "logo-gems-market-gray-usage",
      viewBox: "0 0 195 80",
      url: __webpack_public_path__ + "icons.svg#logo-gems-market-gray",
      toString: function () {
        return this.url;
      }
    }